/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';
const initialState = {
  planType: [],
  rebateProgramList: [],
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  searchResult: {},
  manufacturerList: [],
  isLoading: false,
  earliestQtr: '',
  dramsInvoice: '',
  threshold: '',
  selectedQuarterOption: 'DRAMS Invoice Start Quarter',
  rprtBalThresholdValue: true,
  selectedRow: [],
  disputeAmountForQuarter: [],
  selectRowIndex: 0,
  displayObj: {
    searchResult: {},
    earliestQtr: '',
    dramsInvoice: '',
    threshold: '',
    selectedQuarterOption: 'DRAMS Invoice Start Quarter',
    rprtBalThresholdValue: true,
    selectedRow: [],
    rebateProgramValue: '',
    disputeAmountForQuarter: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_MANNUFACTURER_SUMMERYE:
    //   return { ...state, rebateProgramList: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_MANNUFACTURER_SUMMERYE:
    //   return { ...state, ...action.payload };
    case ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE:
      return {
        ...state,
        dramsInvoice: action.payload,
      };
    case ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE:
      return { ...state, earliestQtr: action.payload };
    case ActionTypes.SET_BALANCE_THRESH:
      return { ...state, threshold: action.payload };
    case ActionTypes.IS_LOADING_MANNUFACTURER_SUMMERY:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.SET_SEARCH_INPUT_MANUFACTURER_SUMMRARY:
      return { ...state, ...action.payload };
    case ActionTypes.GET_MANUFACTURER_LIST_MANUFACTURER_SUMMARY:
      return { ...state, manufacturerList: action.payload };
    case ActionTypes.GET_RESULT_MANUFACTURER_SUMMARY:
      let displayObj = {
        ...state.displayObj,
        searchResult: action.payload,
      };
      return { ...state, searchResult: action.payload, displayObj };
    case ActionTypes.GET_DISPUTE_AMOUNT_FOR_QUARTER:
      let displayObj4 = {
        ...state.displayObj,
        disputeAmountForQuarter: action.payload,
      };
      return {
        ...state,
        disputeAmountForQuarter: action.payload,
        displayObj: displayObj4,
      };

    case ActionTypes.REFRESH_MANUFACTURE_SUMMARY:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_MANUFACTURE_SUMMARY_DISPLAY:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
